// Shared severity classification for rego / WoF / service due dates.
// Returns { days, severity, label, classes } so widgets render consistently.
// severity: "overdue" | "7d" | "14d" | "30d" | "ok" | "none"

const stylesBySeverity = {
  overdue: {
    label: "Overdue",
    badge: "bg-red-600 text-white border-red-700",
    cell: "bg-red-50 border-red-300 text-red-800",
    dot: "bg-red-600",
  },
  "7d": {
    label: "Due ≤ 7 days",
    badge: "bg-orange-500 text-white border-orange-600",
    cell: "bg-orange-50 border-orange-300 text-orange-800",
    dot: "bg-orange-500",
  },
  "14d": {
    label: "Due ≤ 14 days",
    badge: "bg-amber-400 text-zinc-900 border-amber-500",
    cell: "bg-amber-50 border-amber-300 text-amber-800",
    dot: "bg-amber-400",
  },
  "30d": {
    label: "Due ≤ 30 days",
    badge: "bg-yellow-300 text-zinc-900 border-yellow-400",
    cell: "bg-yellow-50 border-yellow-300 text-yellow-800",
    dot: "bg-yellow-300",
  },
  ok: {
    label: "OK",
    badge: "bg-zinc-100 text-zinc-700 border-zinc-300",
    cell: "bg-zinc-50",
    dot: "bg-emerald-500",
  },
  none: {
    label: "—",
    badge: "bg-zinc-50 text-zinc-400 border-zinc-200",
    cell: "bg-zinc-50",
    dot: "bg-zinc-300",
  },
};

export function expiryStatus(isoDate) {
  if (!isoDate) return { days: null, severity: "none", ...stylesBySeverity.none };
  const target = new Date(isoDate);
  if (Number.isNaN(target.getTime())) return { days: null, severity: "none", ...stylesBySeverity.none };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  target.setHours(0, 0, 0, 0);
  const days = Math.round((target - today) / (1000 * 60 * 60 * 24));
  let severity = "ok";
  if (days < 0) severity = "overdue";
  else if (days <= 7) severity = "7d";
  else if (days <= 14) severity = "14d";
  else if (days <= 30) severity = "30d";
  return { days, severity, ...stylesBySeverity[severity] };
}

// True when the expiry is overdue or within 30 days (back-compat for Fleet page).
export function isExpiringSoon(isoDate) {
  const s = expiryStatus(isoDate);
  return s.severity !== "ok" && s.severity !== "none";
}

// Rank used to sort the dashboard alert list — lower = more urgent.
const RANK = { overdue: 0, "7d": 1, "14d": 2, "30d": 3, ok: 4, none: 5 };
export function severityRank(severity) {
  return RANK[severity] ?? 99;
}

export function formatDaysLabel(days) {
  if (days === null || days === undefined) return "—";
  if (days < 0) return `${Math.abs(days)}d overdue`;
  if (days === 0) return "Due today";
  if (days === 1) return "1 day";
  return `${days} days`;
}
